<template>
    <div v-if="options_loaded && passed_filter">
        <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
            <span>{{ title }}</span>
            <span v-for="option in filtered_option_list">
                <label>
                    <input type="radio" v-model="localTarget"
                           :name="'radio_' + component_id"
                           :value="option.value"
                    > {{ option.label }}
                </label>
            </span>
        </div>
        <div v-if="loading">
            <p>Loading Options</p>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./Question.vue";
    import {nextTick} from "vue";

    export default {
        mixins: [
            Question
        ],
        watch: {
            'filtered_option_list': function (new_val, old_val) {
                nextTick(()=>{
                    var options = $('#radio--' + this.component_id + ' input').not('.icheck').not('.skip_icheck');

                    options.addClass('icheck').iCheck({
                        checkboxClass: 'checkboxstyle',
                        radioClass: 'radiostyle',
                        selectClass: 'selectstyle'
                    });

                    $('.icheck').iCheck('update');

                    options.on('ifChecked', (e) => {
                        this.localTarget = parseInt(e.target.value);
                    });
                });
            }
        }
    }
</script>
